exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.titleBox[data-v-427d10ba] {\n  height: 2rem;\n  line-height: 2rem;\n}\n.brackets[data-v-427d10ba] {\n  display: inline-block;\n  width: 0.4rem;\n  height: 0.6rem;\n}\n.brackets img[data-v-427d10ba] {\n  margin-top: -0.1rem;\n  width: 100%;\n}\n.contentList[data-v-427d10ba] {\n  height: 1.4rem;\n  line-height: 1.4rem;\n}", ""]);

// exports
